import { useRef } from 'react'
import { FieldWrapper, TitleInfo, Switch, TwoOptionSwitch} from '~/components'
import * as styles from './index.module.css'

export default function TwoOptionField({ field, form, title, info, showSpinner, secondOption, reverseLayout, alternateBackground, larger, children, innerRef, ...props }) {
  const isChecked = Array.isArray(field.value) ? field.value.includes(props?.value) : field.value
  const isDisabled = props.disabled
  const clickRef = useRef()

  const SwitchUi = secondOption ? TwoOptionSwitch : Switch;

  const wrapperClick = e => {
    if (e.clientX !== 0 && e.clientY !== 0) {
      (innerRef || clickRef)?.current?.click()
    }
  }

  return (
    <FieldWrapper reverseLayout={reverseLayout} noPadding column alternateBackground={alternateBackground} isDisabledVisible={isDisabled} larger={larger} onClick={wrapperClick}>
      <SwitchUi 
        innerRef={innerRef || clickRef}
        isChecked={!isChecked}
        name={field.name} 
        field={field}
        form={form}
        onChange={field.onChange} 
        onBlur={field.onBlur} 
        option1={title}
        option2={secondOption}
        showSpinner={showSpinner}
        {...props} 
      />
      {children}
    </FieldWrapper>
  )
}
